import * as React from 'react';
import NumberFormat from 'react-number-format';
import { Button, Col, Form, FormGroup, Input, Row } from 'reactstrap';
import {
  IGlobalContextProps,
  withGlobalContext,
} from 'src/context/global.context';
import {/* deleteUser,*/ updateUser } from 'src/services';
import { isNumber } from 'src/utils/validation';

interface IConsultantModalProps {
  changeStep: (stepNumber: number) => void;
  toggleCreateConsultantModal: () => void;
}

const CreateConsultantSecondStep: React.SFC<
  IConsultantModalProps & IGlobalContextProps
> = ({ changeStep, context, toggleCreateConsultantModal }) => {
  const [state, setState] = React.useState({
    company: {
      address1: '',
      city: '',
      companyCode: '',
      companyName: '',
      zipcode: '',
    },
    invalid: false,
  });

  const companyCodeValue = state.company.companyCode && state.company.companyCode.replace(/\s|_/g, '');
  const isValid =
    (!!!state.company.companyCode ||  companyCodeValue .length=== 14 ) 
     &&
    (!!!state.company.zipcode || isNumber(state.company.zipcode));

  const handleChange = (e: React.ChangeEvent<Element>) => {
    setState({
      ...state,
      company: {
        ...state.company,
        [(e.target as any).name]: (e.target as any).value,
      },
    });
  };

  const handleUser = async () => {
    if (isValid) {
      const updatedUser = await updateUser({ company: state.company });
      if (updatedUser) {
        changeStep(3);
      }
    } else {
      setState({
        ...state,
        invalid: true,
      });
    }
  };

  const toggleModalWithDeleteUser = () => {
    if (context.isCreating) {
     // deleteUser();
      context.updateUser(true);
      context.toggleIsCreating();
      changeStep(1);
    }
    toggleCreateConsultantModal();
  };

  return (
    <Form className='p-5'>
      <FormGroup>
        <Input
          type='text'
          name='companyName'
          placeholder='Nom de votre société'
          value={state.company.companyName}
          onChange={handleChange}
        />
      </FormGroup>
      <FormGroup>
        <Input
          type='text'
          name='companyCode'
          placeholder='SIRET de votre société'
          invalid={
           state.invalid  || (!!state.company.companyCode &&  companyCodeValue .length !== 14 )
          }
          value={state.company.companyCode}
          onChange={handleChange}
          tag={NumberFormat}
          format="### ### ### #####" 
          mask='_'
        />
      </FormGroup>
      <FormGroup>
        <Input
          type='text'
          name='address1'
          placeholder='Adresse de votre société'
          value={state.company.address1}
          onChange={handleChange}
        />
      </FormGroup>
      <FormGroup>
        <Input
          type='text'
          name='zipcode'
          placeholder='Code postal'
          invalid={
            state.invalid &&
            !!state.company.zipcode &&
            !isNumber(state.company.zipcode)
          }
          value={state.company.zipcode}
          onChange={handleChange}
          tag={NumberFormat}
          format="#####" 
        />
      </FormGroup>
      <FormGroup>
        <Input
          type='text'
          name='city'
          placeholder='Ville'
          value={state.company.city}
          onChange={handleChange}
        />
      </FormGroup>
      <Row className='d-flex justify-content-end'>
        <Col xs='6'>
          <Button
            className='text-uppercase text-white bg-dark border-0 mt-3'
            onClick={toggleModalWithDeleteUser}
          >
            Annuler
          </Button>
        </Col>
        <Col xs='6'>
          <Button
            className='text-uppercase text-white bg-secondary float-right border-0 mt-3'
            onClick={handleUser}
          >
            Étape 3 {'>'}
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export const CreateConsultantSecondStepWithGlobalContext = withGlobalContext(
  CreateConsultantSecondStep
);



// WEBPACK FOOTER //
// ./src/components/shared/Modals/CreateConsultantModal/CreateConsultantSecondStep.tsx